import React from 'react';
import {
  Button,
  Flex,
  Link,
  Modal,
  Text,
  Title
} from '@gjensidige/builders-components';

interface PropertyIdExplanationProps {
  isOpen: boolean;
  propertyIdExampleIllustration: string;
  onCloseExplanationModal: () => void;
}

export const PropertyIdExplanationModal = ({
  isOpen,
  onCloseExplanationModal,
  propertyIdExampleIllustration
}: PropertyIdExplanationProps) => (
  <Modal
    open={isOpen}
    onClick={onCloseExplanationModal}
    strict={true}
    aria-label="Hjälp om fastighetsinformation"
    closeLabel="Stäng information"
    className="property-id-modal"
  >
    <Flex justify="center" className="property-id-modal-container">
      <Flex>
        <div className="custom-error-modal-text-container">
          <Title as="h2" size="5" className="property-id-title">
            Vad är en fastighetsbeteckning?
          </Title>
          <Text size="body">
            En fastighetsbeteckning är en unik beteckning för varje fastighet
            som delas ut av Lantmäteriet. Behöver du hitta din
            fastighetsbeteckning, använd{' '}
            <Link
              target="_blank"
              icon={false}
              rel="noopener noreferrer"
              href="https://www.lantmateriet.se/sv/kartor/vara-karttjanster/min-karta/hitta-fastighetsbeteckning-i-min-karta/"
              className="helper-and-contact-link"
            >
              Lantmäteriets e-tjänst Min karta
            </Link>
            .
          </Text>
          <Title as="h2" size="5" className="property-id-second-title">
            Så ser en fastighetsbeteckning ut
          </Title>
          <Text size="body">
            En fastighetsbeteckning består av traktens namn, ett blocknummer och
            eventuellt ett enhetsnummer. Ibland kan även kommunnamnet finnas med
            i början. I fastighetsbeteckningen "Helsingborg Pålsjö 1:24" är
            Helsingborg kommunnamnet, Pålsjö traktnamnet, 1 blocknumret och 24
            enhetsnumret.
          </Text>
        </div>
      </Flex>
      <Flex direction="column" gap="none">
        <div className="modal-align-content-center property-id-image">
          <img
            src={propertyIdExampleIllustration}
            alt=""
            className="property-id-image"
          />
        </div>
        <div className="modal-align-content-center">
          <Button
            variant="primary"
            className="error-primary-button"
            onClick={onCloseExplanationModal}
          >
            Stäng
          </Button>
        </div>
      </Flex>
    </Flex>
  </Modal>
);
